import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Alert, Badge, Col, Divider, Row, Space, Statistic, Tabs } from 'antd';

import {
  CASH,
  CASH_APPROACH,
  CREATING,
  HISTORICAL_SCENARIO,
  instrumentTypes,
  OPTION,
  selectors,
} from 'state';
import PlayersTable from './PlayersTable';
import HistoricalTimeline from './HistoricalTimeline';
import SessionDetails from './SessionDetails';
import PlayersEvolutionGraph from './PlayersEvolutionGraph';
import OverviewCards from '../../TraineeSession/MarketsTab/PortfolioOverview/OverviewCards';
import PortfolioValueEvolution from '../../TraineeSession/MarketsTab/PortfolioOverview/PortfolioValueEvolution';
import PriceGraph from '../../TraineeSession/MarketsTab/PortfolioOverview/PriceGraph';
import ClientDealingOverviewTable from './ClientDealingOverviewTable';

const OverviewClientDealing: React.FC = () => {
  const session = useSelector(selectors.activeSession);
  const isCreating = session.status === CREATING;

  const noAssets = !session.underlying_assets.length;
  const isHistorical = session.scenario_type === HISTORICAL_SCENARIO;
  const [key, setKey] = useState<string>('overview');
  const showClientStats = session.status !== CREATING;
  return (
    <div>
      <Row style={{ flexFlow: 'row nowrap' }} gutter={40}>
        <Col flex="0 5 26%">
          <SessionDetails />
        </Col>
        {isHistorical && (
          <Col flex="0 1 24%">
            <HistoricalTimeline />
          </Col>
        )}
        <Col flex="0 1 29.5%">{!isCreating && <PlayersEvolutionGraph />}</Col>
      </Row>

      {noAssets && (
        <Alert
          message="Please select and save the Session Instruments (Session Settings tab) in order to finish creating the session."
          type="error"
          showIcon
          style={{ marginTop: '16px', marginBottom: 16 }}
        />
      )}

      {/*<Divider />*/}
      <Tabs
        style={{ flex: 1 }}
        // defaultActiveKey={trainerContext.instrumentType}
        defaultActiveKey={key}
        onChange={val => {
          // if (val === 'cash') return trainerContext.setShowCash(true);

          // trainerContext.setShowCash(false);
          setKey(val);
          // trainerContext.setInstrumentType(val);
          // setInstrument(
          //   _financialInstruments.filter(fn =>
          //     instrumentFilter(
          //       fn,
          //       instrumentTypes[parseInt(val)].type,
          //       instrumentTypes[parseInt(val)].name
          //     )
          //   )[0] || instrument
          // );
        }}
      >
        <Tabs.TabPane key="overview" tab={<span>Overview</span>} />
        {showClientStats && (
          <Tabs.TabPane
            key="client_dealing"
            tab={<span>Client Dealing</span>}
          />
        )}
      </Tabs>
      {key === 'overview' && <PlayersTable />}
      {key === 'client_dealing' && <ClientDealingOverviewTable />}
    </div>
  );
};

export default OverviewClientDealing;
